// Shared bits for the llama player's curator tools and the /sampler crates page.
export const ax = { withCredentials: true };

export const COLORS = {
  green: { hex: "#34D399", label: "Green", hint: "family friendly — plays everywhere" },
  blue: { hex: "#60A5FA", label: "Blue", hint: "heavy, not offensive" },
  red: { hex: "#F87171", label: "Red", hint: "explicit — hidden from the public player" },
};
export const NO_COLOR = "#FBBF24";
export const colorHex = (c) => COLORS[c]?.hex || NO_COLOR;

export const REEL_DEFAULT = { source: "imports" };
export const DEFAULT_SAMPLE = 22;

// Start points in play order: the starred favourite first, then the rest in time order.
export const cueStarts = (cues = []) => [...cues.filter((c) => c.starred), ...cues.filter((c) => !c.starred)].map((c) => c.at);

export const normPath = (p = "/") => `/${p.split("?")[0].split("#")[0].replace(/^\/+|\/+$/g, "")}`;

export const clock = (s) => {
  if (!isFinite(s) || isNaN(s) || s < 0) return "0:00";
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = String(Math.floor(s % 60)).padStart(2, "0");
  return h ? `${h}:${String(m).padStart(2, "0")}:${sec}` : `${m}:${sec}`;
};

export const lenLabel = (n) => (n === Infinity ? "Full" : n < 60 ? `${n}s` : clock(n));

export const errText = (e, fallback) => e?.response?.data?.detail || fallback;
